/**
 * Identidad humana de los agentes (capa de presentación). Los códigos N1–N5 siguen siendo
 * la verdad en BD/logs/evals; estos nombres espejan agent_configs.display_name/oficio
 * (migración 0017) y homenajean a las letras chilenas.
 */
export interface IdentidadAgente {
  code: string;
  nombre: string;
  oficio: string;
  /** Tinte del avatar monograma (sistema cerrado de UI). */
  tinte: string;
}

export const AGENTES: Record<string, IdentidadAgente> = {
  N1: { code: 'N1', nombre: 'Nicanor', oficio: 'el Lector', tinte: 'bg-celeste/40 text-azul-profundo' },
  N2: { code: 'N2', nombre: 'Marcela', oficio: 'la Editora de Mesa', tinte: 'bg-[#EAF4FB] text-azul-profundo' },
  N3: { code: 'N3', nombre: 'Violeta', oficio: 'la Redactora', tinte: 'bg-emerald-50 text-emerald-700' },
  N4: { code: 'N4', nombre: 'Gabriela', oficio: 'la Auditora', tinte: 'bg-amber-50 text-amber-700' },
  N5: { code: 'N5', nombre: 'Pablo', oficio: 'el Creativo', tinte: 'bg-azul-profundo/10 text-azul-profundo' },
  A0: { code: 'A0', nombre: 'Memo', oficio: 'el Archivador', tinte: 'bg-slate-500/10 text-slate-700' },
  A1: { code: 'A1', nombre: 'Andrés', oficio: 'el Consultor', tinte: 'bg-emerald-500/10 text-emerald-700' },
  A4: { code: 'A4', nombre: 'Iris', oficio: 'la Lectora', tinte: 'bg-slate-500/10 text-slate-700' },
  A5: { code: 'A5', nombre: 'Eco', oficio: 'el Transcriptor', tinte: 'bg-slate-500/10 text-slate-700' },
  A6: { code: 'A6', nombre: 'Emilia', oficio: 'la Entrenadora', tinte: 'bg-rose-500/10 text-rose-700' },
  // Redactores de capítulo de la DIA (A2/A3 + A7–A18).
  A2: { code: 'A2', nombre: 'Roberto', oficio: 'el Descriptor (Cap. 1)', tinte: 'bg-sky-500/10 text-sky-700' },
  A3: { code: 'A3', nombre: 'Diamela', oficio: 'la Argumentadora (Cap. 2)', tinte: 'bg-violet-500/10 text-violet-700' },
  A7: { code: 'A7', nombre: 'Fernanda', oficio: 'la Normativa (Cap. 3)', tinte: 'bg-sky-500/10 text-sky-700' },
  A8: { code: 'A8', nombre: 'Tomás', oficio: 'el Territorial (Cap. 4)', tinte: 'bg-sky-500/10 text-sky-700' },
  A9: { code: 'A9', nombre: 'Camila', oficio: 'la Estratégica (Cap. 5)', tinte: 'bg-sky-500/10 text-sky-700' },
  A10: { code: 'A10', nombre: 'Ignacio', oficio: 'el Negociador (Cap. 6)', tinte: 'bg-sky-500/10 text-sky-700' },
  A11: { code: 'A11', nombre: 'Valentina', oficio: 'la Comprometida (Cap. 7)', tinte: 'bg-sky-500/10 text-sky-700' },
  A12: { code: 'A12', nombre: 'Matías', oficio: 'el Certificador (Cap. 8)', tinte: 'bg-sky-500/10 text-sky-700' },
  A13: { code: 'A13', nombre: 'Josefa', oficio: 'la Sintetizadora (Cap. 9)', tinte: 'bg-sky-500/10 text-sky-700' },
  A14: { code: 'A14', nombre: 'Andrea', oficio: 'la Registradora (Cap. 10)', tinte: 'bg-sky-500/10 text-sky-700' },
  A15: { code: 'A15', nombre: 'Cristóbal', oficio: 'el Monitor (Cap. 11)', tinte: 'bg-sky-500/10 text-sky-700' },
  A16: { code: 'A16', nombre: 'Paula', oficio: 'la Participativa (Cap. 12)', tinte: 'bg-sky-500/10 text-sky-700' },
  A17: { code: 'A17', nombre: 'Rodrigo', oficio: 'el Firmante (Cap. 13)', tinte: 'bg-sky-500/10 text-sky-700' },
  A18: { code: 'A18', nombre: 'Sofía', oficio: 'la Ejecutiva (Cap. 14)', tinte: 'bg-sky-500/10 text-sky-700' },
  ORQ: { code: 'ORQ', nombre: 'Víctor', oficio: 'el Director', tinte: 'bg-azul-noche/10 text-white' },
};

export function agente(code: string): IdentidadAgente {
  return AGENTES[code] ?? { code, nombre: code, oficio: '', tinte: 'bg-slate-100 text-slate-700' };
}
